import { combineReducers } from 'redux';
import coreReducer from '../../services/core/reducer';
import sessionReducer from '../../services/auth/reducer';
import nonprofitReducer from '../../services/nonprofits/reducer';

const rootReducer = combineReducers({
  coreState: coreReducer,
  sessionState: sessionReducer,
  nonprofitState: nonprofitReducer,
});

export default rootReducer;
